var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container"}},[_c('dv-border-box-3',[_c('div',{attrs:{"id":"gauge-content"}},[_c('div',{ref:"planChart_ref",attrs:{"id":"planChart"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }